import type { CreateTradeRequestDto } from '@utility-nyc/react-query-sdk';

const TRADE_SUBMISSION_TIMEOUT_MS = 30000;

type TradeEventCorrelation = {
  currentTradeRequestId: string;
  pendingClientRequestId: string | null;
  eventTradeRequestId: string;
  eventClientRequestId?: string;
};

const createClientRequestId = () =>
  'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (token) => {
    const random = Math.floor(Math.random() * 16);

    if (token === 'x') {
      return random.toString(16);
    }

    return ['8', '9', 'a', 'b'][Math.floor(Math.random() * 4)] ?? '8';
  });

const toRecentTradeMatchRequest = ({
  type,
  components,
  shares,
}: CreateTradeRequestDto) => ({ type, components, shares });

const isCorrelatedPendingTradeEvent = ({
  pendingClientRequestId,
  eventClientRequestId,
}: Pick<
  TradeEventCorrelation,
  'pendingClientRequestId' | 'eventClientRequestId'
>) =>
  pendingClientRequestId !== null &&
  eventClientRequestId === pendingClientRequestId;

const isCurrentTradeEvent = ({
  currentTradeRequestId,
  eventTradeRequestId,
}: Pick<TradeEventCorrelation, 'currentTradeRequestId' | 'eventTradeRequestId'>) =>
  currentTradeRequestId === eventTradeRequestId;

const shouldVerifyUntrackedCreatedEvent = (
  correlation: TradeEventCorrelation,
) =>
  !isCurrentTradeEvent(correlation) &&
  !isCorrelatedPendingTradeEvent(correlation);

const getSubmissionExpiryDelay = (
  submissionStartedAt: number | null,
  now = Date.now(),
) =>
  Math.max(
    0,
    TRADE_SUBMISSION_TIMEOUT_MS - (now - (submissionStartedAt ?? now)),
  );

export {
  TRADE_SUBMISSION_TIMEOUT_MS,
  createClientRequestId,
  getSubmissionExpiryDelay,
  isCorrelatedPendingTradeEvent,
  isCurrentTradeEvent,
  shouldVerifyUntrackedCreatedEvent,
  toRecentTradeMatchRequest,
};
export type { TradeEventCorrelation };
